import React from "react";
import {getActiveInteractionId, useTrackingGroup} from "../context/TrackingContext";
import {dataLayerDonationSubmit, dataLayerDonationSubmitError} from "../events/donations";
import {rhythmToString, typeToString} from "../utils/donationStringMappers";
import {EVENT_NAMES} from "tracking/core/eventNames";

export function useDonationSubmitTracking() {
    const {startInteraction, endInteraction} = useTrackingGroup();

    const getOptions = React.useCallback(() => {
        const id = getActiveInteractionId();
        return id ? {eventGroupId: id} : undefined;
    }, []);

    const onSubmitClick = React.useCallback(() => {
        startInteraction(EVENT_NAMES.DONATION_SUBMIT);
    }, [startInteraction]);

    const onSubmitSuccess = React.useCallback(
        (formData?: any, donation_id?: string | null) => {
            try {
                const amount = formData?.amount;
                const rhythm = rhythmToString(formData?.donationRhythm);
                const typeStr = typeToString(formData?.donationType);
                const priority = formData?.priority;
                const payment = formData?.paymentMethod ? String(formData.paymentMethod) :
                    undefined;
                dataLayerDonationSubmit(
                    {
                        currency: "EUR",
                        donation_id: donation_id ?? undefined,
                        donation_amount: typeof amount === "number" ? amount : undefined,
                        donation_rhythm: rhythm,
                        donation_priority: priority ?? undefined,
                        donation_payment_method: payment,
                        donation_type: typeStr,
                    },
                    getOptions()
                );
            } catch {
                /* noop */
            }
        },
        [getOptions]
    );

    const onSubmitError = React.useCallback(
        (message?: string | null, formData?: any) => {
            try {
                const amount = formData?.amount;
                const typeStr = typeToString(formData?.donationType);
                dataLayerDonationSubmitError(
                    {
                        currency: "EUR",
                        donation_amount: typeof amount === "number" ? amount : undefined,
                        donation_type: typeStr,
                        error_message: message ?? undefined,
                    },
                    getOptions()
                );
            } catch {
                /* noop */
            }
        },
        [getOptions]
    );

    return {
        onSubmitClick,
        onSubmitSuccess,
        onSubmitError,
        endInteraction,
    } as const;
}
